import type { EventDto, Role } from '../../api/types';

type Maybe<T> = T | null | undefined;

export function canCreateEvent(role: Maybe<Role>, hasGuestAccess = false): boolean {
  if (role === 'organizer' || role === 'admin') return true;
  // Ordinary users may create events only while an admin has opened tables for guests.
  return role === 'user' && hasGuestAccess;
}

export function canEditEvent(params: {
  role: Maybe<Role>;
  event: Maybe<EventDto>;
  currentUserTelegramId: Maybe<string>;
}): boolean {
  const { role, event, currentUserTelegramId } = params;
  if (!role) return false;
  if (!event) return false;
  if (event.status === 'cancelled') return false;

  if (role === 'admin') return true;
  const isOwner = currentUserTelegramId != null && event.createdByTelegramId === currentUserTelegramId;
  return isOwner;
}

export function canReserveSlot(params: {
  role: Maybe<Role>;
  event: Maybe<EventDto>;
  currentUserTelegramId: Maybe<string>;
}): boolean {
  const { role, event, currentUserTelegramId } = params;
  if (!role) return false;
  if (!event) return false;
  if (event.status === 'cancelled') return false;

  if (role === 'admin') return true;
  const isOwner = currentUserTelegramId != null && event.createdByTelegramId === currentUserTelegramId;
  return isOwner;
}
